import http from 'src/services/httpService';
import errorHandler from 'src/utils/error-handler';
export function acessarHefloClick() {
  const GetRedirectUrl = async () => {
    try {
      const response = await http.get(`/Heflo/Authenticate`);
      if (response.data.mensagemErro && response.data.mensagemErro !== '') {
        throw response.data.mensagemErro;
      }
      return response.data.redirectUrl;
    } catch (error) {
      errorHandler(error);
    }
  };

  GetRedirectUrl().then((urlHeflo) => {
    if (urlHeflo) {
      //---------------------------------
      //A url retornada pelo Heflo contém caracteres ({  })
      //que fazem a url ser truncada se for feito window.open
      //Então por isso o tratamento abaixo
      //----------------------------------
      const link = document.createElement('a');
      link.href = urlHeflo;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  });
}
